import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { signOut } from "./../slices/auth";
import { canopy } from "./../theme";

const HouseIcon = ({ size = 26 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={canopy.green}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 10.5 12 3l9 7.5"></path>
    <path d="M5 9.5V21h14V9.5"></path>
    <path d="M9 21v-6h6v6"></path>
  </svg>
);

export default function ButtonAppBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSignOut = () => {
    dispatch(signOut());
  };
  const handleNavigate = (path) => {
    handleClose();
    navigate(path);
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            aria-label="menu"
            sx={{ mr: 1, color: canopy.greenDark }}
            onClick={handleClick}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flexGrow: 1 }}>
            <HouseIcon />
            <Typography
              variant="h6"
              component="div"
              sx={{ color: canopy.greenDark, fontWeight: 800 }}
            >
              Shelby Estates
            </Typography>
          </Box>
          {user?.uid && (
            <Button onClick={handleSignOut} sx={{ color: canopy.green, fontWeight: 800 }}>
              Sign out
            </Button>
          )}
        </Toolbar>
        <Menu
          id="demo-positioned-menu"
          aria-labelledby="demo-positioned-button"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <MenuItem onClick={() => handleNavigate("profile")}>Profile</MenuItem>
          <MenuItem onClick={() => handleNavigate("account")}>
            My account
          </MenuItem>
          {user?.role?.includes("admin") && (
            <MenuItem onClick={() => handleNavigate("accounts")}>
              Accounts
            </MenuItem>
          )}
          {user?.role?.includes("admin") && (
            <MenuItem onClick={() => handleNavigate("payments")}>
              Payments
            </MenuItem>
          )}
        </Menu>
      </AppBar>
    </Box>
  );
}
